import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { AuthenticationService } from '../../core/services/authentication.service';
import { TokenStorageService } from '../../core/services/token-storage.service';
import { Router, RouterModule } from '@angular/router';
import { AlertDialogComponent } from '../../shared/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { EncryptionDescriptionService } from '../../core/services/encryption-decryption.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatCardModule, TranslateModule, MatButtonModule, ReactiveFormsModule, MatGridListModule, RouterModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {

  form: FormGroup;
  constructor(private router: Router, private formBuilder: FormBuilder, private service: AuthenticationService,
    private tokenStorage: TokenStorageService, public dialog: MatDialog, private cryptService: EncryptionDescriptionService) {
  }
  ngOnInit() {
    this.form = this.formBuilder.group({
      userName: ['', [Validators.required, Validators.maxLength(30), Validators.pattern('[a-zA-Z0-9.-]*')]],
      // Login must accept existing accounts. Password-strength rules belong to
      // registration/password-change flows, not credential verification.
      password: ['', [Validators.required]],
    });

  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: 'OK'
        }
      },
    });
  }
login() {
  const userName = String(this.f['userName'].value ?? '').trim();
  const password = String(this.f['password'].value ?? '');
  if (!userName || !password) {
    this.form.markAllAsTouched();
    return;
  }

  let pHash: string;
  try {
    pHash = this.cryptService.encryptWithPublicKey(password);
  } catch {
    this.openAlert('Unable to secure the login request. Please reload the page and try again.');
    return;
  }
  const formValue = { ...this.form.value };
  formValue.userName = userName;
  formValue.password = pHash;

  formValue.isPublic = false; 

  this.service.authenticate(formValue).subscribe({
    next: (res) => {
      this.tokenStorage.saveToken(res["data"]["access_token"]);
      this.tokenStorage.setPermissions();
      this.service.getUserPermissions().subscribe({
        next: (res) => {
          this.tokenStorage.savePermission(res["data"]);
        }
      });
    },
    error: (e) => {
      this.f['password'].setValue('');
      if (e?.status == 409 || e?.status == 403) {
        if (e?.error?.errors !== null) {
          for (const property in e.error.errors) {
            this.openAlert(e.error.errors[property]);
          }
        } else {
          this.openAlert(e?.error?.message);
        }
      }
    }
  });
}

}
